const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5014/api/v1';

const get = async (endpoint) => {
  const res = await fetch(`${API_BASE_URL}${endpoint}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

const analyticsAPI = {
  getOverview: () => get('/analytics/overview'),
  getTemplateStats: () => get('/analytics/templates'),
  getTimeSeries: (days = 30) => get(`/analytics/timeseries?days=${days}`),
};

export default analyticsAPI;
